import React, { useState, useCallback, useMemo } from "react";
import { Card, Table, Button, Modal } from 'antd';
import { useDispatch } from 'react-redux';
import {Link} from 'react-router-dom';
import NewCustomRuleForm from "../forms/newCustomRuleForm";
import { deleteRule } from "../../stateManagement/actions/data";

const CustomRulesList = ({list, reloadData}) => {

    const dispatch = useDispatch();

    // Consolidated modal state management
    const [modalState, setModalState] = useState({
        newRule: { visible: false },
        deleteRule: { visible: false, id: null }
    });    
    
    // Memoized modal handlers to prevent unnecessary recreations
    const showNewRuleModal = useCallback(() => {
        setModalState(prev => ({
            ...prev, 
            newRule: { visible: true }
        }));
    }, []);

    const handleNewRuleCancel = useCallback(() => {
        setModalState(prev => ({
            ...prev, 
            newRule: { visible: false }
        }));
    }, []);

    const showDeleteRuleModal = useCallback((id) => {
        setModalState(prev => ({
            ...prev, 
            deleteRule: { visible: true, id }
        }));
    }, []);

    const handleDeleteRuleCancel = useCallback(() => {
        setModalState(prev => ({
            ...prev, 
            deleteRule: { visible: false, id: null }
        }));
    }, []);

    // Memoized columns to prevent unnecessary recreations
    const customRulesColumns = useMemo(() => [
        {
            key: 'provider',
            title: 'Platform',
            dataIndex: 'provider',
            sorter: (a,b) => a.provider.localeCompare(b.provider)
        },
        {
            key: 'ruleType',
            title: 'Type',
            dataIndex: 'ruleType',
        },
        {
            key: 'cellValue',
            title: 'Report value',
            dataIndex: 'cellValue',
        },
        {
            key: 'returnedValue',
            title: 'Platform value',
            dataIndex: 'returnedValue',
        },
        {
            key: 'action',
            title: 'Actions',
            render: (data) => (<Button onClick={() => showDeleteRuleModal(data._id)} type="link" danger>Delete</Button>)
        }
    ], [showDeleteRuleModal])

    // Memoized delete handler
    const handleDelete = useCallback(() => {
        dispatch(deleteRule(modalState.deleteRule.id));
        reloadData();
        handleDeleteRuleCancel()
    }, [
        dispatch, 
        modalState.deleteRule.id, 
        reloadData, 
        handleDeleteRuleCancel
    ]);

    return(<>
        <Modal 
            title="Add new custom rule" 
            open={modalState.newRule.visible} 
            onCancel={handleNewRuleCancel}
            footer={null}
        >
            <NewCustomRuleForm reloadData={reloadData}/>
        </Modal>
        <Card title="Custom rules list:" size="small" extra={<Link onClick={showNewRuleModal}>New</Link>}>
            <Table 
                columns={customRulesColumns} 
                dataSource={list} 
                rowKey="_id"
                pagination={{
                    showSizeChanger: true,
                    showQuickJumper: true,
                    showTotal: (total) => `Total: ${total}`
                }}
            />
        </Card>
        <Modal 
            title="Confirmation required" 
            open={modalState.deleteRule.visible} 
            onCancel={handleDeleteRuleCancel}
            onOk={handleDelete}
        >
            <p>Are you sure?</p>
        </Modal>
    </>)
}

export default CustomRulesList;